/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module VrfContextModule
 */

import { Collection } from 'ajs/modules/data-model/factories/collection.factory';
import { VRFContext } from 'ajs/modules/vrf-context/factories/vrf-context.item.factory';
import {
    VRF_CONTEXT_COLL_DATASOURCE_TOKEN,
    VRF_CONTEXT_TOKEN,
} from '../vrf-context.tokens';

/**
 * Token for name.in field.
 */
const NAME_IN_TOKEN = 'name.in';

/**
 * @description
 *
 *   VRF Context Collection.
 *
 * @author Aravindh Nagarajan, Alex Klyuev
 */
export class VRFContextCollection extends Collection {
    constructor(args = {} as any) {
        const allDataSources = {
            list: {
                source: VRF_CONTEXT_COLL_DATASOURCE_TOKEN,
                transformer: 'ListDataTransformer',
                transport: 'ListDataTransport',
                fields: ['config'],
            },
        };

        const extendedArgs = {
            objectName: 'vrfcontext',
            windowElement: 'lazy-load',
            allDataSources,
            defaultDataSources: 'list',
            restrictCreateOnEssentialLicense: true,
            ...args,
        };

        if (!args.allowManagementVrf) {
            if (!extendedArgs.params) {
                extendedArgs.params = {};
            }

            extendedArgs.params.exclude = NAME_IN_TOKEN;
            extendedArgs.params[NAME_IN_TOKEN] = 'management';
        }

        super(extendedArgs);

        this.itemClass_ = this.getAjsDependency_(VRF_CONTEXT_TOKEN);
    }

    /**
     * Returns true if any custom VRF Contexts exist, as in there exists a VRF Context that is
     * neither the default 'management' or 'global' VRF Contexts.
     */
    public hasCustomVRFContext(): boolean {
        const { items: vrfContexts } = this;

        const defaultVrfContextNames = [
            'management',
            'global',
        ];

        return vrfContexts.some((vrfContext: VRFContext) => {
            const name = vrfContext.getName();

            return !defaultVrfContextNames.includes(name);
        });
    }
}

VRFContextCollection.ajsDependencies = [
    VRF_CONTEXT_TOKEN,
];
